class AmbientAudioService {
  constructor() {
    this.audio = new Audio();
    this.audio.loop = true;
    this.currentTrackId = null;
    this.tracks = [];
    this.isLoaded = false;
    this.listeners = [];

    // Notificar cambios de estado (play/pause)
    this.audio.addEventListener('play', () => this.notify());
    this.audio.addEventListener('pause', () => this.notify());
  }

  static getInstance() {
    if (!AmbientAudioService.instance) {
      AmbientAudioService.instance = new AmbientAudioService();
    }
    return AmbientAudioService.instance;
  }

  subscribe(listener) {
    this.listeners.push(listener);
    // Retornar función para desuscribirse
    return () => {
      this.listeners = this.listeners.filter(l => l !== listener);
    };
  }

  notify() {
    this.listeners.forEach(listener => listener(this));
  }

  async loadTracks(fetchWithAuth, apiUrls, user = null) {
    if (this.isLoaded) return this.tracks;
    
    try {
      const response = await fetchWithAuth(apiUrls.ambientTracks, { authUser: user });
      const data = await response.json();
      if (Array.isArray(data)) {
        this.tracks = data;
        this.isLoaded = true;
        this.notify();
      }
      return this.tracks;
    } catch (error) {
      console.error('AmbientAudioService: Error loading tracks', error);
      return [];
    }
  }

  getTracks() {
    return this.tracks;
  }

  setTrack(url, id) {
    if (this.currentTrackId === id) return;
    
    const wasPlaying = !this.audio.paused;
    this.audio.src = url;
    this.currentTrackId = id;
    
    if (wasPlaying) {
      this.play();
    }
    this.notify();
  }

  setVolume(volume) {
    const safeVolume = Math.max(0, Math.min(1, parseFloat(volume)));
    if (this.audio.volume === safeVolume) return;
    this.audio.volume = safeVolume;
    this.notify();
  }

  play() {
    if (!this.audio.src) return;
    this.audio.play().catch(error => {
      console.warn('AmbientAudioService: Error playing audio', error);
    });
  }

  pause() {
    this.audio.pause();
  }

  stop() {
    this.pause();
    this.audio.currentTime = 0;
  }

  isPlaying() {
    return !this.audio.paused;
  }
}

export const ambientAudioService = AmbientAudioService.getInstance();
